import React from 'react';
import {
  QAlert,
  QButton,
  QCloseButton,
  QFormControl,
  QInput,
  QModal,
  QModalActions,
  QModalBody,
  QModalHeader,
  QStack,
  QText,
} from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';

type TokenModalProps = {
  token: string;
  onClose: () => void;
};

export const TokenModal: React.FC<TokenModalProps> = ({ token, onClose }) => {
  const { t } = useTranslation();
  const copyToken = () => {
    navigator.clipboard.writeText(token);
  };

  return (
    <QModal onClose={onClose} size="lg" isOpen={Boolean(token)}>
      <QModalHeader>
        <QText>{t('developerApi.tokenCreatedTitle')}</QText>
        <QCloseButton onClick={onClose} />
      </QModalHeader>
      <QModalBody>
        <QStack spacing={4}>
          <QAlert
            status="warning"
            title={t('developerApi.storeSecurelyTitle')}
            description={t('developerApi.storeSecurelyMessage')}
          />
          <QFormControl label={t('developerApi.apiTokenLabel')}>
            <QStack direction="row">
              <QInput data-cy="tokenDisplay" data-testid="tokenDisplay" value={token} isReadOnly />
              <QButton variant="outline" onClick={copyToken}>
                {t('developerApi.copyToken')}
              </QButton>
            </QStack>
          </QFormControl>
          <QText>{t('developerApi.tokenLostWarning')}</QText>
        </QStack>
      </QModalBody>
      <QModalActions>
        <QButton onClick={onClose}>{t('common.done')}</QButton>
      </QModalActions>
    </QModal>
  );
};
